import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/hub.css";

const Hub = ({ userRole }) => {
    const navigate = useNavigate();
    const [isProdReady] = useState({ // set to true if the feature is stable for production. still always works on localhost.
        training: true,
        prosodyTraining: false,
        phraseTraining: true,
        webDemo: false,
        createUser: true
    });
    const hasTrainingAccess = ["training-user", "multi-user", "admin"].includes(userRole);

    const isLocalhost = useMemo(() => {
        return window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    }, []);

    const handleLogout = () => {
        // clear jwt token and redirect to login
        localStorage.removeItem("jwt");
        navigate("/login");
    };
    
    return (
        <div className="hub-container">
            <h1>Welcome to the Intersign AI Hub</h1>
            
            {/* show training pages for users with training access */}
            {hasTrainingAccess && (
                <div className="feature-container">
                    <button
                        onClick={() => navigate("/training")}
                        disabled={!isLocalhost && !isProdReady.training}
                        className={!isProdReady.training ? 'maintenance' : ''}
                    >
                        ASL Training
                    </button>
                    {!isProdReady.training && (
                        <span className="maintenance-indicator">
                            🔧 Under Maintenance {isLocalhost && "(Available on localhost)"}
                        </span>
                    )}
                </div>
            )}

            {hasTrainingAccess && (
                <div className="feature-container">
                    <button
                        onClick={() => navigate("/phrase-training")}
                        disabled={!isLocalhost && !isProdReady.phraseTraining}
                        className={!isProdReady.phraseTraining ? 'maintenance' : ''}
                    >
                        Phrase-based Prosody Training
                    </button>
                    {!isProdReady.phraseTraining && (
                        <span className="maintenance-indicator">
                            🔧 Under Maintenance {isLocalhost && "(Available on localhost)"}
                        </span>
                    )}
                </div>
            )}

            {hasTrainingAccess && (
                <div className="feature-container">
                    <button
                        onClick={() => navigate("/batch-training")}
                        disabled={!isLocalhost && !isProdReady.prosodyTraining}
                        className={!isProdReady.prosodyTraining ? 'maintenance' : ''}
                    >
                        Atomic-based Prosody Training
                    </button>
                    {!isProdReady.prosodyTraining && (
                        <span className="maintenance-indicator">
                            🔧 Under Maintenance {isLocalhost && "(Available on localhost)"}
                        </span>
                    )}
                </div>
            )}

            {/* show web demo button if user is not a training-user */}
            {userRole !== "training-user" && (
                <div className="feature-container">
                    <button 
                        onClick={() => navigate("/web-demo")}
                        disabled={!isLocalhost && !isProdReady.webDemo}
                        className={!isProdReady.webDemo ? 'maintenance' : ''}
                    >
                        ASL Web Demo
                    </button>
                    {!isProdReady.webDemo && (
                        <span className="maintenance-indicator">
                            🔧 Under Maintenance {isLocalhost && "(Available on localhost)"}
                        </span>
                    )}
                </div>
            )}

            {/* show create user button for admins */}
            {userRole === "admin" && (
                <div className="feature-container">
                    <button 
                        onClick={() => navigate("/create-user")}
                        disabled={!isLocalhost && !isProdReady.createUser}
                        className={!isProdReady.createUser ? 'maintenance' : ''}
                    >
                        Create User
                    </button>
                    {!isProdReady.createUser && (
                        <span className="maintenance-indicator">
                            🔧 Under Maintenance {isLocalhost && "(Available on localhost)"}
                        </span>
                    )}
                </div>
            )}

            <button onClick={handleLogout} className="logout-button">
                Logout
            </button>
        </div>
    );
};

export default Hub;
